// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetAppSystemWebApiListRequestModel from '../../model/get-app-system-web-api-list-request-model';
import GetAppSystemWebApiListRequestDTO from '../dto/get-app-system-web-api-list-request-dto';
import dtoSchema from '../schemas/get-app-system-web-api-list-request-schema';

export default abstract class GetAppSystemWebApiListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetAppSystemWebApiListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.appSystemId = data.appSystemId;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  appSystemId?: number;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetAppSystemWebApiListRequestDTO>): GetAppSystemWebApiListRequestModel;
  static toModel(dto: DeepPartial<GetAppSystemWebApiListRequestDTO> | undefined | null): GetAppSystemWebApiListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetAppSystemWebApiListRequestDTO> | undefined | null): GetAppSystemWebApiListRequestModel | undefined {
    return dto ? new GetAppSystemWebApiListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetAppSystemWebApiListRequestModel> | GetAppSystemWebApiListRequestModel): GetAppSystemWebApiListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      appSystemId: unwrapped.appSystemId,
      searchCriteria: unwrapped.searchCriteria,
    } as GetAppSystemWebApiListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetAppSystemWebApiListRequestModel, can not map to GetAppSystemWebApiListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
